export const jaanoFramerIntegration = {
  chatbot: "Jaano.ai",
  platform: "Framer",
  desc: `Framer users can integrate Jaano.ai in just a few clicks by embedding the chatbot script inside the custom code section. 
  This lets you bring AI-powered interactions to your visually designed Framer websites, improving user experience and engagement with minimal effort.`,

  steps: [
    {
      title: "Step 1: Sign Into Your Jaano.ai Account and Copy Your Embed Code",
      instructions: [
        "Log into your Jaano.ai account and navigate to the Dashboard page.",
        "Click on the chatbot you want to integrate into your Framer website.",
        "Once inside the chatbot, go to the AI Playground page.",
        "Click the Connect tab at the top of the page.",
        "Click Copy Script to copy the embed code.",
      ],
    },
    {
      title: "Step 2: Sign Into Your Framer Website and Embed Your Chatbot",
      instructions: [
        "Sign in to your Framer website and open your project dashboard.",
        "Click on the website project you want to embed your Jaano.ai chatbot into.",
        "In the editor, locate the target page and click the three-dot icon next to it.",
        "Click Settings to open the settings panel for that page.",
        "Scroll down to find the 'Custom Code' section.",
        "Paste your embed code into the 'Start of <head> tag' box and click Save.",
        "You should now see the chatbot icon floating on your website.",
      ],
    },
  ],
  congratulations:
    "Congratulations! Your Jaano.ai bot is now ready to use on your Framer website.",
  metaUsage: {
    note: "Note:",
    tip: "You can customize the appearance and colors of your bot in the Jaano.ai dashboard under Settings → Chat Interface.",
  },
};

export default jaanoFramerIntegration;
